// extracted by mini-css-extract-plugin
export default {"tile":"TFqb4pbk","icon":"e72D0-UN","small":"_41H0d5ax"};